import { render } from "./WebWorkerMessage.vue?vue&type=template&id=6a7d31fa"
import script from "./WebWorkerMessage.vue?vue&type=script&lang=js"
export * from "./WebWorkerMessage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__